import './footer.scss';

import React from 'react';

const YEAR = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="app-footer">
      <span className="app-footer__brand">Timora</span>
      <span className="app-footer__sep">·</span>
      Panel de administración
      <span className="app-footer__sep">·</span>
      <span className="app-footer__copy">© {YEAR}</span>
    </footer>
  );
};

export default Footer;
